import { SocialButton } from '@ulule/owl-kit-components/dist/next.esm';
import * as React from 'react';
export default {
  SocialButton,
  React
};